import React from "react";
import PropTypes from 'prop-types';

import style from "./Offices.css";
import Button from "../Button";
import LinkBar from "../LinkBar";

class Offices extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      selectedIdx: 0
    };
  }

  handleSelectOffice (selectedIdx) {
    this.setState({ selectedIdx });
  }

  render () {
    const offices = this.props.offices;
    const selectedOffice = offices[this.state.selectedIdx];
    const url = `/openings?office=${this.state.selectedIdx}`;
    const links = offices.map((office) => office.name);

    return (
      <div className={style.offices}>
        <h3 className={style.title}>
          Our offices across Europe
        </h3>
        <LinkBar
          links={links}
          selected={this.state.selectedIdx}
          activeStyle={{ color: "#ff5c39" }}
          onClick={(idx) =>
            this.handleSelectOffice(idx)
          } />
        <div className={style.containerFluid}>
          <div className={style.row}>
            <div className={style.col}>
              <img className={style.image} src={selectedOffice.image} />
            </div>
            <div className={style.col}>
              <h4 className={style.selectedOfficeTitle}>
                {selectedOffice.title}
              </h4>
              <div
                className={style.selectedOfficeBody}
                dangerouslySetInnerHTML={{ __html: selectedOffice.body }} />
              <Button
                to={url}
                label={selectedOffice.linkLabel} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Offices.propTypes = {
  offices: PropTypes.array.isRequired
};

export default Offices;



// WEBPACK FOOTER //
// ./component/Offices/index.js